import { useStore } from 'hooks/shop'
import React, { useEffect } from 'react'
import 'stylesheets/MainAppStyles/Store.css'

const Store = () => {
    const { isLoading, getItemsImages, paths, imagesUrls } = useStore()
    useEffect(() => {
        getItemsImages()
    }, [])

    // useEffect(() => {
    //     console.log(imagesUrls)
    // }, [imagesUrls])

    useEffect(() => {
        const body = document.querySelector('body');
        body.style.overflowY = 'auto'
    }, [])

    const handleBuyItem = () => {
        window.open('https://www.instagram.com/treepilotapp/')
    }
    return (
        <div className='shop-main-container'>
            <img className='banner' src="https://firebasestorage.googleapis.com/v0/b/tree-pilot-auth.appspot.com/o/appSources%2Fbannerstore.webp?alt=media&token=b39f5ca3-d6a5-401b-909b-47f9f6838809" alt="" />
            <h2 className='title'>¡Mira nuestros nuevos productos y píde el tuyo!</h2>
            <p className='description'>Estamos contruyendo el procesador de pagos, por el momento, escríbenos solicitando el producto que desees</p>
            <div className="items-container">
                {imagesUrls.map(item => {
                    const arrayNameAndPrize = item[0].split('/')[1].split('$')
                    const category = arrayNameAndPrize[1].split('#')[1]
                    const itemName = arrayNameAndPrize[0].replace(/-/g, ' ')
                    const prize = parseFloat(arrayNameAndPrize[1].split('#')[0])
                    return (
                        <div className="item" key={item[0]} onClick={handleBuyItem}>
                            <div className="images-item-container">
                                {
                                    <img src={item[1]} />
                                    // item.map((el, index) => {
                                    //     return index > 0 ? <img key={index} src={el} /> : ''
                                    // })
                                }
                            </div>
                            <div className="item-info">
                                <p className='category'>{category}</p>
                                <h3>{itemName}</h3>
                                <p className='prize'>S/{prize.toFixed(2)}</p>
                            </div>
                        </div>
                    )
                })}
            </div>
        </div>
    )
}

export default Store